export const SELECT_EXTERIOR_COLOR = 'SELECT_EXTERIOR_COLOR'
export const RESET_EXTERIOR_COLOR = 'RESET_EXTERIOR_COLOR'

export const SELECT_KILOMETER = 'SELECT_KILOMETER'
export const RESET_KILOMETER = 'RESET_KILOMETER'

export const SELECT_NOMOR_POLIS = 'SELECT_NOMOR_POLIS'
export const RESET_NOMOR_POLIS = 'RESET_NOMOR_POLIS'

